import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getMoeDataRequest: ['response'],
    getMoeDataSuccess: ['response'],
    getMoeDataFailure: ['error'],
})

export const getMoeDataTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
})

/* ------------- Reducers ------------- */
const getMoeDataSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
    })
const getMoeDataFailure = (state, { error }) =>
    state.merge({
        error: true,
        response: error,
    })
const getMoeDataRequest = state => state.merge()

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_MOE_DATA_REQUEST]: getMoeDataRequest,
    [Types.GET_MOE_DATA_SUCCESS]: getMoeDataSuccess,
    [Types.GET_MOE_DATA_FAILURE]: getMoeDataFailure,
})
